import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';

export const longTermRoutes = [
  /**
   * [0]
   */
  {
    path: `/car-news/long-term/gql-:articleId.:ext`,
    exact: true,
    enableLooseEtag: true,
    page: getLoadablePage(
      () => import(/* webpackChunkName: "long-term-gql" */ '../pages/long-term/gql/long-term-definition')
    ),
    chunkName: 'long-term-gql',
    resolveLocationInParallelToPagePreload: true,
  },
  /**
   * [1]
   */
  {
    path: `/car-news/long-term/atom-:articleId.:ext`,
    exact: true,
    enableLooseEtag: true,
    page: getLoadablePage(
      () => import(/* webpackChunkName: "long-term-atom" */ '../pages/long-term/atom/long-term-definition')
    ),
    chunkName: 'long-term-atom',
    resolveLocationInParallelToPagePreload: true,
  },
];
